import React, { Component } from "react";

export default class footer extends Component {
  render() {
    return (
      <>
        <div class="footer out-footer">
          <div class="copyright">
            <p>
              Copyright © by
              <a href="https://jk77.live" target="_blank">
                jk77.live
              </a>
              2026
            </p>
          </div>
        </div>
      </>
    );
  }
}
